export enum Country {    
    UnitedStates = 1,
    Other = 0
}